import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  questionWidgetTitle: {
    id: 'authoring.questionwidget.question.questionWidgetTitle',
    defaultMessage: 'Question',
    description: 'Question Title',
  },
  placeholder: {
    id: 'authoring.problemEditor.questionwidget.placeholder',
    defaultMessage: 'Enter your question',
    description: 'Placeholder text for tinyMCE editor',
  },
});

export default messages;
